<app-page-wrapper [title]="'teams' | i18n">
  <div class="tw-flex tw-w-full tw-h-full tw-gap-4 tw-pb-4 sm:tw-flex-col sm:tw-gap-3">
    <div
      class="tw-flex tw-h-full tw-w-[64%] tw-flex-col tw-rounded-2xl tw-bg-color-surface-card tw-shadow-card-elevated sm:tw-w-full"
    >
      <div
        class="tw-flex tw-h-full tw-flex-col tw-gap-4 tw-overflow-hidden tw-rounded-2xl tw-px-4 tw-pb-4 tw-pt-4"
      >
        <div
          class="tw-flex tw-h-[46px] tw-w-full tw-gap-1 tw-rounded-2xl tw-bg-color-surface-input tw-p-1"
        >
          <button
            type="button"
            class="tw-flex-1 tw-rounded-xl tw-px-4 tw-py-[9px] tw-text-sm tw-transition-all"
            [ngClass]="
              activeTab === 'myTeams'
                ? 'tw-bg-color-surface-elevated tw-font-semibold tw-text-dt-text-headings tw-shadow-elevation-control'
                : 'tw-font-medium tw-text-dt-text-tertiary'
            "
            (click)="setTab('myTeams')"
          >
            {{ "myTeamsTab" | i18n }}
          </button>
          <button
            type="button"
            class="tw-flex-1 tw-rounded-xl tw-px-4 tw-py-[9px] tw-text-sm tw-transition-all"
            [ngClass]="
              activeTab === 'invitations'
                ? 'tw-bg-color-surface-elevated tw-font-semibold tw-text-dt-text-headings tw-shadow-elevation-control'
                : 'tw-font-medium tw-text-dt-text-tertiary'
            "
            (click)="setTab('invitations')"
          >
            {{ "invitationsTab" | i18n }}
          </button>
        </div>

        <div class="tw-flex tw-justify-end">
          <app-gloss-button
            class="tw-shrink-0 sm:tw-w-full"
            [options]="createTeamButton"
          ></app-gloss-button>
        </div>

        <div class="tw-flex tw-w-full tw-flex-col">
          <div class="tw-h-px tw-w-full tw-bg-white/[.82]"></div>
          <div class="tw-h-px tw-w-full tw-bg-black/10"></div>
        </div>

        <div
          appGlossScroll
          class="tw-flex tw-flex-1 tw-flex-col tw-gap-6 tw-overflow-y-auto tw-p-2"
        >
          @if (activeTab === "myTeams") {
            <!-- orgsLoaded: organizations$ starts out as [], so don't show "no teams" before the
                 org list has actually been read. -->
            @if (!orgsLoaded || (isLoadingTeams && teamRows.length === 0)) {
              <p class="tw-text-sm tw-text-neutral-400">{{ "loading" | i18n }}</p>
            } @else if (teamRows.length === 0) {
              <div class="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-py-16 tw-text-center">
                <span class="tw-text-base tw-font-semibold tw-text-dt-text-headings">{{
                  "teamsEmptyTitle" | i18n
                }}</span>
                <span class="tw-max-w-[420px] tw-text-sm tw-text-dt-text-disabled">{{
                  "teamsEmptyDescription" | i18n
                }}</span>
              </div>
            } @else {
              @for (row of teamRows; track row.collectionId) {
                <button
                  type="button"
                  class="tw-flex tw-h-20 tw-w-full tw-items-center tw-justify-between tw-gap-3 tw-rounded-2xl tw-bg-color-surface-card tw-p-4 tw-text-left tw-shadow-list hover:tw-bg-color-surface-hover"
                  (click)="openTeamDetail(row)"
                >
                  <div class="tw-flex tw-min-w-0 tw-items-center tw-gap-3">
                    <div
                      class="tw-flex tw-h-12 tw-w-12 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-color-surface-brand tw-font-montserrat tw-text-lg tw-font-semibold tw-leading-none tw-text-color-intent-brand"
                    >
                      {{ row.name.charAt(0).toUpperCase() }}
                    </div>
                    <div class="tw-flex tw-min-w-0 tw-flex-col tw-gap-1">
                      <span
                        class="tw-truncate tw-text-sm tw-font-semibold tw-leading-none tw-text-dt-text-headings"
                        >{{ row.name }}</span
                      >
                      <span
                        class="tw-truncate tw-text-sm tw-font-medium tw-leading-none tw-text-dt-text-tertiary"
                        >{{ row.subtitle }}</span
                      >
                    </div>
                  </div>
                  <div class="tw-flex tw-shrink-0 tw-flex-col tw-items-end tw-gap-2">
                    <span [ngClass]="badgeClass[row.badgeKey]">{{
                      badgeLabelKey[row.badgeKey] | i18n
                    }}</span>
                    <span
                      class="tw-whitespace-nowrap tw-text-xs tw-font-medium tw-leading-none tw-text-dt-text-tertiary"
                      >{{ row.sharedLabel }}</span
                    >
                  </div>
                </button>
              }
            }
          } @else {
            @if (isLoadingInvitations && invitationRows.length === 0) {
              <p class="tw-text-sm tw-text-neutral-400">{{ "loading" | i18n }}</p>
            } @else if (invitationRows.length === 0) {
              <div class="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-py-16 tw-text-center">
                <span class="tw-text-base tw-font-semibold tw-text-dt-text-headings">{{
                  "noInvitationsTitle" | i18n
                }}</span>
                <span class="tw-max-w-[420px] tw-text-sm tw-text-dt-text-disabled">{{
                  "noInvitationsDescription" | i18n
                }}</span>
              </div>
            } @else {
              @for (row of invitationRows; track row.id) {
                <div
                  class="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-3 tw-rounded-2xl tw-bg-color-surface-card tw-p-4 tw-shadow-list sm:tw-flex-col sm:tw-items-stretch"
                >
                  <div class="tw-flex tw-min-w-0 tw-items-center tw-gap-3">
                    <div
                      class="tw-flex tw-h-12 tw-w-12 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-color-surface-brand tw-font-montserrat tw-text-lg tw-font-semibold tw-leading-none tw-text-color-intent-brand"
                    >
                      {{ row.name.charAt(0).toUpperCase() }}
                    </div>
                    <div class="tw-flex tw-min-w-0 tw-flex-col tw-gap-0.5">
                      <span
                        class="tw-truncate tw-text-sm tw-font-semibold tw-leading-5 tw-text-dt-text-headings"
                        >{{ row.name }}</span
                      >
                      @if (row.subtitle) {
                        <span
                          class="tw-truncate tw-text-sm tw-font-medium tw-leading-5 tw-text-dt-text-tertiary"
                          >{{ row.subtitle }}</span
                        >
                      }
                    </div>
                  </div>
                  <div class="tw-flex tw-shrink-0 tw-flex-col tw-items-end tw-gap-2">
                    <span [ngClass]="invitationBadgeClass[row.badgeKey]">{{
                      invitationBadgeLabelKey[row.badgeKey] | i18n
                    }}</span>
                    <!-- Only a still-Invited row has anything to act on; Accepted waits for the
                         admin, Rejected is informational. -->
                    @if (row.invitation.status === "Invited") {
                      <div class="tw-flex tw-items-center tw-gap-2 sm:tw-w-full">
                        <!-- Each button is hidden once the backend has rejected that action for
                             good (see isActionBlocked). -->
                        @if (!isActionBlocked(row, "decline")) {
                          <button
                            type="button"
                            class="tw-inline-flex tw-h-10 tw-items-center tw-justify-center tw-rounded-2xl tw-bg-color-surface-sunken tw-px-6 tw-text-sm tw-font-semibold tw-text-dt-text-headings hover:tw-bg-color-surface-hover disabled:tw-opacity-50 sm:tw-flex-1"
                            [disabled]="pendingInvitationIds.has(row.id)"
                            (click)="declineInvitation(row)"
                          >
                            {{ "decline" | i18n }}
                          </button>
                        }
                        @if (!isActionBlocked(row, "accept")) {
                          <button
                            type="button"
                            class="tw-inline-flex tw-h-10 tw-items-center tw-justify-center tw-rounded-2xl tw-bg-color-action-primary tw-px-6 tw-text-sm tw-font-semibold tw-text-color-text-on-action tw-shadow-elevation-card disabled:tw-opacity-50 sm:tw-flex-1"
                            [disabled]="pendingInvitationIds.has(row.id)"
                            (click)="acceptInvitation(row)"
                          >
                            {{ "accept" | i18n }}
                          </button>
                        }
                      </div>
                      <!-- Both actions rejected for good: the row has none left, so say why here
                           rather than leave only the earlier toasts (#6260). -->
                      @for (reasonKey of blockedReasons(row); track reasonKey) {
                        <p
                          class="tw-m-0 tw-max-w-xs tw-text-right tw-text-xs tw-leading-4 tw-text-dt-text-error sm:tw-text-left"
                          data-testid="invitation-blocked-reason"
                        >
                          {{ reasonKey | i18n }}
                        </p>
                      }
                    }
                  </div>
                </div>
                @if (row.invitation.status === "Rejected") {
                  <div
                    class="tw-flex tw-flex-col tw-gap-1 tw-rounded-2xl tw-bg-color-status-info-bg tw-px-4 tw-py-3 tw-text-color-status-info-text"
                    data-testid="invitation-not-approved-tip"
                  >
                    <span class="tw-text-sm tw-font-semibold tw-leading-5">{{
                      "inviteNotApprovedTitle"
                        | i18n: row.invitation.invitedByEmail || ("teamOwner" | i18n)
                    }}</span>
                    <span class="tw-text-xs tw-leading-4">{{
                      "inviteNotApprovedBody" | i18n
                    }}</span>
                  </div>
                }
              }
            }
          }
        </div>
      </div>
    </div>

    <div class="tw-flex tw-w-[34%] tw-flex-col tw-gap-4 sm:tw-hidden">
      <app-teams-info-panel></app-teams-info-panel>
    </div>
  </div>
</app-page-wrapper>
